module.exports = __webpack_public_path__ + "img/18e90.b10d50b7.png";